module.exports = __webpack_public_path__ + "static/media/tamanzakat.041d3b1c.png";